import $ from "jquery";
import Swiper from "swiper";

import { Mousewheel, EffectCreative, Navigation } from "swiper/modules";

export default class GalleryCarousel {
  $el = $("section.gallery-carousel");

  constructor() {
    if (!this.$el.length) return;

    this.init();
  }

  init() {
    this.setupCarousel();
  }

  setupCarousel() {
    Swiper.use([Mousewheel, EffectCreative, Navigation]);

    const $carousel = this.$el.find(".swiper").get(0);

    new Swiper($carousel, {
      slidesPerView: 1,
      effect: "creative",
      centeredSlides: true,
      creativeEffect: {
        progressMultiplier: 1,
        limitProgress: 2.8,
        prev: {
          opacity: 1,
          scale: 0.8,
          translate: [-220, 0, 0],
        },
        next: {
          opacity: 1,
          scale: 0.8,
          translate: [220, 0, 0],
        },
      },
      spaceBetween: 10,
      mousewheel: {
        releaseOnEdges: true,
        forceToAxis: true,
      },
      loop: true,
    });
  }
}
